import 'bootstrap/dist/css/bootstrap.min.css';
// Must be global: page-level CSS imports are not reliably loaded on client-side nav in Next.js 13 production.
import '@updater/lumis-agent/lumis-agent.css';
import { WorkSansLoader } from 'components/WorkSansLoader/WorkSansLoader';
import { AppProps } from 'next/app';
import {
  ApolloClient,
  Datadog,
  Environment,
  ErrorBoundary,
  GlobalStyles,
  MockServiceWorker,
} from 'services';
import { ProviderAuth, persistAuth } from 'services/auth';
import { FullstoryProvider } from 'services/fullstory/fullstoryProvider';
import { GrowthbookExperimentTracker } from 'services/growthbook/GrowthbookExperimentTracker';
import { GrowthbookWrapper } from 'services/growthbook/GrowthbookWrapper';
import { initIdentity } from 'services/identity';

persistAuth();
initIdentity();

export default function App({ Component, pageProps, router }: AppProps) {
  // SEO pages (/local/*) must export as complete static HTML, so they skip
  // the app shell: MockServiceWorker renders null until client JS (which
  // would export empty pages), and auth/Apollo/tracking must not load on
  // public crawlable pages.
  if (router.pathname === '/local' || router.pathname.startsWith('/local/')) {
    return <Component {...pageProps} />;
  }

  return (
    <>
      {/* Funnel OneTrust consent lives in _document (see the note there):
          next/head scripts here can re-execute on client navigation, and
          OtAutoBlock.js is not re-run-safe. */}
      <WorkSansLoader />
      <ErrorBoundary>
        <GlobalStyles />
        <Environment>
          <GrowthbookWrapper>
            <GrowthbookExperimentTracker />
            <Datadog>
              <FullstoryProvider />
              <MockServiceWorker>
                <ProviderAuth>
                  <ApolloClient>
                    <Component {...pageProps} />
                  </ApolloClient>
                </ProviderAuth>
              </MockServiceWorker>
            </Datadog>
          </GrowthbookWrapper>
        </Environment>
      </ErrorBoundary>
    </>
  );
}
